import { Typography } from 'antd';
import { PersonAddIcon, PersonOutlineIcon } from 'common/icons';
import { useTranslation } from 'react-i18next';
import { useAuth } from 'src/auth';
import { Organization } from 'src/pages/organization/organization.model';

import { ActionsList } from '../actions-list/actions-list.component';
import { OnboardingAction } from '../actions-list/actions-list.model';
import {
  getAccountMembersUrl,
  getAccountWorkspacesUrl,
} from '../actions-list/actions-list.util';
import * as Styled from './onboarding-progress.style';

const { Title, Paragraph } = Typography;

interface OnboardingProgressViewProps {
  percentage?: number;
  organization: Organization | null;
}

const OnboardingProgressView = ({
  percentage,
  organization,
}: OnboardingProgressViewProps) => {
  const { t } = useTranslation();
  const { user } = useAuth();

  const userName = user?.first_name || user?.name || t('common.user');

  const actions: OnboardingAction[] = [
    {
      id: 'invite',
      label: t('onboarding.action.invite'),
      icon: <PersonAddIcon />,
      onClick: () =>
        window.open(
          getAccountMembersUrl(
            organization?.workspace_id || '',
            organization?.id || '',
          ),
          '_blank',
        ),
    },
    {
      id: 'account',
      label: t('onboarding.action.account'),
      icon: <PersonOutlineIcon />,
      onClick: () =>
        window.open(
          getAccountWorkspacesUrl(
            organization?.workspace_id || '',
            organization?.id || '',
          ),
          '_blank',
        ),
    },
  ];

  return (
    <Styled.ProgressWrapper>
      <Styled.SceneImage
        style={{
          backgroundImage: `url('/assets/onboarding-progress-scene.gif')`,
        }}
      />
      <Styled.ProgressBar
        percentage={percentage || 0}
        data-testid={`onboarding-progress-bar-${percentage || 0}`}
      />
      <Styled.ContentLayout>
        <Styled.LeftContent>
          <Title level={4}>
            {t('onboarding.progress.title', { name: userName })}
          </Title>
          <Paragraph>{t('onboarding.progress.duration')}</Paragraph>
          <Paragraph>{t('onboarding.progress.description')}</Paragraph>
        </Styled.LeftContent>

        <Styled.RightContent>
          <Paragraph>{t('onboarding.action.title')}</Paragraph>
          <ActionsList actions={actions} />
        </Styled.RightContent>
      </Styled.ContentLayout>
    </Styled.ProgressWrapper>
  );
};

export { OnboardingProgressView };
